'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToolbarRadioButton", {
    enumerable: true,
    get: function() {
        return ToolbarRadioButton;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const _useToolbarRadioButton = require("./useToolbarRadioButton");
const _useToolbarRadioButtonStylesstyles = require("./useToolbarRadioButtonStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const ToolbarRadioButton = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useToolbarRadioButton.useToolbarRadioButton_unstable)(props, ref);
    (0, _useToolbarRadioButtonStylesstyles.useToolbarRadioButtonStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useToolbarRadioButtonStyles_unstable')(state);
    return (0, _reactbutton.renderToggleButton_unstable)(state);
});
ToolbarRadioButton.displayName = 'ToolbarRadioButton';
